import Vue from "vue";

Vue.filter("number_format", (str) =>
  ("" + str).replace(/\d(?=(\d{3})+$)/g, "$&,")
);
